'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage4/components/quote-summary-panel.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _panel = require('@marmalade/panel');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _constants = require('../../constants');
var _charity = require('../../selectors/charity');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.stages[3].formId;
var QuoteSummaryPanel = function (_Component) {
  _inherits(QuoteSummaryPanel, _Component);
  function QuoteSummaryPanel() {
    _classCallCheck(this, QuoteSummaryPanel);
    return _possibleConstructorReturn(this, (QuoteSummaryPanel.__proto__ || Object.getPrototypeOf(QuoteSummaryPanel)).apply(this, arguments));
  }
  _createClass(QuoteSummaryPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        lgScreen = _props.lgScreen,
        quote = _props.quote,
        donation = _props.donation,
        giftAid = _props.giftAid;
      var Element = lgScreen ? _panel.PanelAside : _panel.Panel;
      return _react2.default.createElement(Element, {
        className: 'cover-panel',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        },
        __self: this
      }, _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        },
        __self: this
      }, 'Quote summary'), _react2.default.createElement(SummaryRow, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        },
        __self: this
      }, _react2.default.createElement('p', {
        style: {
          marginBottom: '0'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        },
        __self: this
      }, quote ? quote.cover : null, ' days insurance premium:'), _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        },
        __self: this
      }, quote ? '\xA3' + quote.premium : null)), _react2.default.createElement(SummarySeparator, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        },
        __self: this
      }), donation ? _react2.default.createElement(_react2.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }, _react2.default.createElement(SummaryRow, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }, _react2.default.createElement('p', {
        style: {
          marginBottom: '0'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        },
        __self: this
      }, 'Donation to Centrepoint charity:'), _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        },
        __self: this
      }, '\xA31')), giftAid ? _react2.default.createElement('small', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        },
        __self: this
      }, 'including gift aid') : null, _react2.default.createElement(SummarySeparator, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        },
        __self: this
      })) : null, _react2.default.createElement(SummaryRow, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        },
        __self: this
      }, _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        },
        __self: this
      }, 'Total payment'), _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        },
        __self: this
      }, '\xA3', quote ? (Number(quote.premium) + (donation ? 1 : 0)).toFixed(2) : '--.--')));
    }
  }]);
  return QuoteSummaryPanel;
}(_react.Component);
QuoteSummaryPanel.propTypes = {
  lgScreen: _propTypes.bool.isRequired,
  quote: _propTypes.object,
  donation: _propTypes.bool,
  giftAid: _propTypes.bool,
  theme: _propTypes.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
  var coverLength = (0, _fieldInfo.getValue)(state, formId, 'cover');
  return {
    lgScreen: (0, _reduxWindow.getWidth)(state) >= 992,
    quote: state.ldiQuote.quotes.find(function (quote) {
      return String(quote.cover) === coverLength;
    }),
    donation: (0, _charity.donation)(state),
    giftAid: (0, _charity.giftAid)(state)
  };
})((0, _glamorous.withTheme)(QuoteSummaryPanel));
var SummaryRow = _glamorous2.default.div({
  display: 'flex',
  justifyContent: 'space-between'
});
var SummarySeparator = _glamorous2.default.hr({
  backgroundColor: '#D2D5D7',
  height: 1
});